import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';

import { TiimeChipsModule, TiimeIconModule } from 'tiime-material';

@Component({
  selector: 'app-attachment-item',
  standalone: true,
  imports: [NgIf, TiimeChipsModule, TiimeIconModule],
  templateUrl: './attachment-item.component.html',
  styleUrl: './attachment-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachmentItemComponent {
  readonly canBeDeleted: InputSignal<boolean> = input.required<boolean>();
  readonly attachmentName: InputSignal<string> = input.required<string>();

  readonly remove: OutputEmitterRef<void> = output<void>();

  emitRemove(): void {
    this.remove.emit();
  }
}
